import script from "./AdBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdBanner.vue?vue&type=script&setup=true&lang=ts"

import "./AdBanner.vue?vue&type=style&index=0&id=53d51758&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53d51758"]])

export default __exports__